import type { FilterSearchConfigMap } from "../services/filter-search-service/types";

import type { IFiltersConfigCategoryItem } from "./category";

export const filtersConfigStatusMap = {
    pending: "pending",
    initial: "initial",
    ready: "ready",
} as const;

export type FiltersConfigStatus = (typeof filtersConfigStatusMap)[keyof typeof filtersConfigStatusMap];

export type FiltersConfig<T extends readonly unknown[] = readonly unknown[], TKey extends string = string> = {
    readonly filtersList: T;
    readonly status: FiltersConfigStatus;
    readonly filtersSearchConfigList?: readonly FilterSearchConfigMap<TKey>[];
};

export type CategoryFiltersConfig<T = unknown> = FiltersConfig<readonly T[]> & {
    readonly categoriesList: readonly IFiltersConfigCategoryItem[];
};
